import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, matchPath } from 'react-router-dom';

export const BRAND = 'Zona Libre';
export const HOME_TITLE = 'Zona Libre - Sitio Oficial';
export const formatTitle = (section) => (section ? `${section} | ${BRAND}` : HOME_TITLE);

const ROUTES = [
  ['/', null],
  ['/login', 'Iniciar sesión'],
  ['/register', 'Crear cuenta'],
  ['/vender', 'Vende en Zona Libre'],
  ['/ads', 'Zona Libre Ads'],
  ['/acerca', 'Acerca de nosotros'],
  ['/terminos', 'Términos y condiciones'],
  ['/privacidad', 'Aviso de privacidad'],
  ['/deslinde', 'Deslinde de responsabilidad'],
  ['/cart', 'Tu carrito'],
  ['/checkout', 'Finalizar compra'],
  ['/thank-you', '¡Gracias por tu compra!'],
  ['/product/:id', 'Producto'],
  ['/store/:sellerId', 'Tienda'],
  ['/profile', 'Mi cuenta'],
  ['/account/personal', 'Información personal'],
  ['/account/details', 'Datos de tu cuenta'],
  ['/account/security', 'Seguridad'],
  ['/account/privacy', 'Privacidad'],
  ['/account/addresses', 'Mis direcciones'],
  ['/account/wallet', 'Mi billetera'],
  ['/account/subscription', 'Suscripciones'],
  ['/my-purchases', 'Mis compras'],
  ['/orders', 'Mis pedidos'],
  ['/order/:orderId', ({ orderId }) => `Pedido #${orderId.slice(0, 8).toUpperCase()}`],
  ['/buyer/favorites', 'Mis favoritos'],
  ['/store-config', 'Configurar mi tienda'],
  ['/seller', 'Panel de vendedor'],
  ['/seller/products', 'Mis publicaciones'],
  ['/seller/orders', 'Mis ventas'],
  ['/seller/orders/:orderId', ({ orderId }) => `Venta #${orderId.slice(0, 8).toUpperCase()}`],
  ['/seller/questions', 'Preguntas de compradores'],
  ['/advertiser/campaigns', 'Mis campañas'],
  ['/delivery', 'Panel de repartidor'],
  ['/delivery/login', 'Acceso repartidores'],
  ['/delivery/register', 'Registro de repartidores'],
  ['/delivery/available', 'Pedidos disponibles'],
  ['/delivery/orders', 'Mis entregas'],
  ['/delivery/history', 'Historial de entregas'],
  ['/delivery/profile', 'Perfil de repartidor'],
  ['/admin/login', 'Admin · Acceso'],
  ['/admin', 'Admin · War Room'],
  ['/admin/warroom', 'Admin · Mapa en vivo'],
  ['/admin/orders', 'Admin · Órdenes'],
  ['/admin/orders/:orderId', ({ orderId }) => `Admin · Orden #${orderId.slice(0, 8).toUpperCase()}`],
  ['/admin/requests', 'Admin · Solicitudes'],
  ['/admin/shipping', 'Admin · Envíos'],
  ['/admin/delivery-drivers', 'Admin · Repartidores'],
  ['/admin/products', 'Admin · Productos'],
  ['/admin/stores', 'Admin · Tiendas'],
  ['/admin/reviews', 'Admin · Reseñas'],
  ['/guest-order/:orderId', 'Consultar pedido'],
  ['/admin/users', 'Admin · Usuarios'],
  ['/admin/marketing', 'Admin · Marketing'],
  ['/admin/ads', 'Admin · Publicidad'],
  ['/admin/seo', 'Admin · SEO'],
  ['/admin/search-engine', 'Admin · Motor de búsqueda'],
  ['/admin/blog', 'Admin · Blog'],
  ['/admin/cms', 'Admin · CMS'],
  ['/admin/payments', 'Admin · Pagos'],
  ['/admin/bank', 'Admin · Banco'],
  ['/admin/taxes', 'Admin · Impuestos'],
  ['/admin/intelligence', 'Admin · Inteligencia'],
  ['/admin/algorithms', 'Admin · Algoritmos'],
  ['/admin/import-export', 'Admin · Importar / Exportar'],
  ['/admin/app-config', 'Admin · App'],
  ['/admin/settings', 'Admin · Configuración general'],
  ['/admin/preferences', 'Admin · Preferencias'],
];

const titleFor = (pathname, search) => {
  if (pathname === '/search') {
    const q = new URLSearchParams(search).get('q');
    return q ? `Resultados para "${q}"` : 'Todos los productos';
  }
  const cat = matchPath('/category/:category', pathname);
  if (cat) return decodeURIComponent(cat.params.category);
  for (const [pattern, section] of ROUTES) {
    const m = matchPath(pattern, pathname);
    if (m) return typeof section === 'function' ? section(m.params) : section;
  }
  return 'Página no encontrada';
};

export const RouteTitle = () => {
  const { pathname, search } = useLocation();
  // The product owns its async title; avoid a competing generic Helmet instance.
  if (matchPath('/product/:id', pathname)) return null;
  return <Helmet><title>{formatTitle(titleFor(pathname, search))}</title></Helmet>;
};

export const PageTitle = ({ title }) => <Helmet><title>{formatTitle(title)}</title></Helmet>;
